import { PRESUPUESTADOR_ADD_COMMENT } from './constants'

export const saveComments = comments => {
  return dispatch => {
    dispatch({
      type: PRESUPUESTADOR_ADD_COMMENT,
      data: comments
    })
  }
}

export function reducer(state, action) {
  if (action.type === PRESUPUESTADOR_ADD_COMMENT) {
      return {
        ...state,
        observation: action.data
      }
  }
  else {
      return state
  }
}
